import React, { useState } from "react"
// import PropTypes from "prop-types"
import CLink from '../cLink'
import { useSpring, animated as a } from '@react-spring/web'
import tw from 'twin.macro';

const HomeEnlacesDirectosInicio = ({content}) => {
  return (
    <nav
      css={tw`absolute hidden md:block -top-30vh right-0`}
    ><ul>
      {content.data.blocks.map((block, i) => (
                <Linea key={block.url+i} i={i} block={block} />
         ))
      }
      </ul>
    </nav>
  )
}

const Linea = ({block, i}) => {
  const [ hover, setHover ] = useState(false)
  const initSpring = useSpring({
    from: {
      transform: 'translate(30rem,0rem)',
      opacity: 0,
    },
    transform: 'translate(0rem,0rem)',
    // scale: isHide ? 0.5 : 1,
    opacity: 1,
    config: {
      tension: 150,
      friction: 50,
    },
    delay: 1000 + 1000 * i,
  })
  const buttomSpring = useSpring({
    
    transform: hover ? 'translate(-2rem,0rem)' : 'translate(0rem,0rem)',
    config: {
      tension: 250,
      friction: 50,
    },
  })
  return (
    <a.li
      style={initSpring}
    ><a.div style={buttomSpring}>
      <CLink to={block.url} css={tw`flex items-center relative justify-end py-1 w-full`}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <div css={tw`text-marron1 dark:text-marron2 font-bold uppercase text-obmed whitespace-nowrap px-3  text-right leading-5`} dangerouslySetInnerHTML={{__html: block.title}} />
        <div css={tw`absolute -right-50vw w-50vw`}>
          <div css={tw`w-full h-0.25 bg-marron1 dark:bg-marron2`} />
        </div>
      </CLink>
      </a.div>
    </a.li>
  )
}

// Header.propTypes = {
//   isHome: PropTypes.bool,
// }

// Header.defaultProps = {
//   isHome: false,
// }

export default HomeEnlacesDirectosInicio
